import type { SidebarUserTypes } from './sidebarUser.types'

export const SidebarUser = ({
  userInitials,
  name,
  mail,
  isPending,
}: SidebarUserTypes) => {
  return (
    <div className="flex items-center gap-3 p-3">
      <div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-full border border-neutralColor5 bg-baseColor">
        <p className="text-base font-medium text-neutralColor">{userInitials}</p>
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="truncate text-base font-medium text-neutralColor">
          {name}
        </p>
        <p className="truncate text-xs font-medium text-neutralColor60">
          {mail}
        </p>
      </div>
      {isPending && (
        <span className="rounded bg-chipBackground px-2 py-1 text-xs font-medium">
          Pending
        </span>
      )}
    </div>
  )
}
